<template>
    <div>
        <div class='searchBox'>
            <el-form :inline="true" :model="searchForm" ref="searchForm">
                <el-form-item label="名称">
                    <el-input v-model="searchForm.mc"></el-input>
                </el-form-item>
                <el-form-item label="资源">
                    <el-input v-model="searchForm.zy"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="search">查询</el-button>
                    <el-button type="primary" @click="resetForm('searchForm')">重置</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class='btnsBox'>
            <el-button type="primary" @click="add">新增</el-button>
            <el-button type="primary" @click="del()" :disabled="multipleSelection.length==0">删除</el-button>
        </div>
        <el-table
            ref="table"
            border
            :data="tableData"
            style="width: 100%"
            row-key="id"
            @selection-change="handleSelectionChange"

        >
            <el-table-column type="selection" width="50"></el-table-column>
            <el-table-column type="index" label="序号" width="50">
                <template slot-scope="scope">{{(currentPage - 1) * pageSize + scope.$index + 1}}</template>
            </el-table-column>
            <el-table-column prop="mc" label="名称"  min-width="180" show-overflow-tooltip></el-table-column>
            <el-table-column prop="xsmc" label="显示名称"  width="180"></el-table-column>
            <el-table-column prop="xsdm" label="显示代码"  width="160"></el-table-column>
            <el-table-column prop="xsdz" label="访问地址" min-width="170" show-overflow-tooltip>
            </el-table-column>
            <el-table-column  label="操作" width="120" fixed='right'>
                <template slot-scope="scope">
                    <el-button type="text"  @click='edit(scope.row)'>编辑</el-button>
                    <el-button type="text"  @click='del(scope.row)'>删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="clear">
            <span class="lf pageNum">共{{total}}条。</span>
            <myPage
            class="rt"
            :total="total"
            :page-size="pageSize"
            :currentPage="currentPage"
            @changePage="changePage"
            ></myPage>
        </div>
        <!-- 新增编辑 -->
        <el-dialog :title='isEdit?"编辑流程":"新建流程"' :visible.sync="dialogVisible" width='900px' lock-scroll :close-on-click-modal="false">
            <el-form :model="form" ref="form" label-width="140px" :rules="formRules">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="名称" prop='mc'>
                            <el-input v-model="form.mc"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="显示名称" prop='xsmc'>
                            <el-input v-model="form.xsmc"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="显示代码" prop='xsdm'>
                            <el-input v-model="form.xsdm"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="父节点"  prop='parentId'>
                            <el-input v-model="form.parentId"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item label="招标人访问地址" prop='zbrdz'>
                    <el-input v-model="form.zbrdz"></el-input>
                </el-form-item>
                <el-form-item label="投标人访问地址" prop='tbrdz'>
                    <el-input v-model="form.tbrdz"></el-input>
                </el-form-item>
                <el-form-item label="专家访问地址" prop='zjdz'>
                    <el-input v-model="form.zjdz"></el-input>
                </el-form-item>
                <el-form-item label="商务标自定义方法名" prop='zdyffm'>
                    <el-input v-model="form.zdyffm"></el-input>
                </el-form-item>
            </el-form>
            <div class='btnBox'>
                <el-button type="primary" @click='saveForm("form")'>确定</el-button>
                <el-button type="primary" @click='resetForm("form")'>重置</el-button>
                <el-button type="primary" @click='cancelForm("form")'>取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import myPage from '../../components/page'
export default {
    name:'',
    components:{
        myPage
    },
    props:[
        'adminLx'
    ],
    data(){
        return{
            searchForm:{
                mc:'',
                zy:''
            },
            tableData:[],
            total:0,
            pageSize:10,
            currentPage:1,
            multipleSelection:[],
            dialogVisible:false,
            isEdit:false,
            form:{
            },
            formRules:{
                mc:[{required:true,message:"必填项",trigger:'blur'}],
                xsmc:[{required:true,message:"必填项",trigger:'blur'}],
                xsdm:[{required:true,message:"必填项",trigger:'blur'}],
                parentId:[{required:true,message:"必填项",trigger:'blur'}],
            }
        }
    },
    methods:{
        getData(){
            let para=this.searchForm;
            para.currentPage=this.currentPage;
            para.pageSize=this.pageSize;
            para.lx=this.adminLx
            this.$api.getLcpz(para).then(res=>{
                if(res.data.meta.success){
                    this.tableData=res.data.data.list;
                    this.total=res.data.data.total
                }else{
                    this.$message({
                        type:'error',
                        message:res.data.meta.message
                    })
                }
            }).catch(()=>{})
        },
        search(){
            this.currentPage=1;
            this.getData();
        },
        //新增
        add(){
            this.dialogVisible=true;
            this.isEdit=false;
            this.form={
            }
        },
        //编辑
        edit(row){
            this.dialogVisible=true;
            this.isEdit=true;
            this.form=Object.assign({},row)
        },
        saveForm(formName){
            this.$refs[formName].validate((valid)=>{
                if(valid){
                    let para=this.form;
                    para.lx=this.adminLx
                    this.$api.saveLcpz(para).then(res=>{
                        if(res.data.meta.success){
                            this.$message({
                                type:'success',
                                message:'保存成功！'
                            })
                            this.dialogVisible=false;
                            this.getData();
                        }else{
                            this.$message({
                                type:'error',
                                message:res.data.meta.message
                            })
                        }
                    }).catch(()=>{})
                }else{
                    return false;
                }
            })
        },
        //重置
        resetForm(formName){
            this.$refs[formName].resetFields();
        },
        cancelForm(formName){
            this.$refs[formName].resetFields();
            this.dialogVisible=false
        },
        //删除
        del(row){
            let text=''
            let para={
                lx:this.adminLx
            }
            if(row){
                text='确定要删除当前的流程吗？'
                para.id=row.id
            }else{
                text='确定要删除选中的流程吗？';
                let ids=''
                this.multipleSelection.forEach(item=>{
                    ids+=item.id+','
                })
                para.id=ids.slice(0,ids.length-1)
            }
            this.$confirm(text, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$api.delLcpz(para).then(res=>{
                    if(res.data.meta.success){
                        this.$message({
                            type:'success',
                            message:'删除成功！'
                        })
                        this.getData();
                    }else{
                        this.$message({
                            type:'error',
                            message:res.data.meta.message
                        })
                    }
                }).catch(()=>{})
            }).catch(() => {
                      
            });
        },
        changePage(val){
            this.currentPage=val;
            this.getData();
        },
        handleSelectionChange(val) {
        this.multipleSelection = val;
      }
    },
    mounted(){
        this.getData();
    }
}
</script>  
<style lang="less" scoped>

</style>